function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1865.71,-115.012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17188,0,0,1.17188,1865.71,115.012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.57,275.258L465.626,275.259C469.97,275.259 473.496,278.841 473.353,283.183C469.173,410.264 364.838,511.999 236.741,511.999C350.417,511.999 442.57,406.006 442.57,275.258Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.977,184.643C52.593,101.167 133.582,41.781 228.815,38.647C233.158,38.504 236.741,42.03 236.741,46.376L236.741,275.258L17.977,184.643Z",
    style: {
      fill: "rgb(249,190,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,442.66C26.499,399.818 0,340.633 0,275.259C0,243.158 6.402,212.557 17.977,184.643L236.741,275.258L69.34,442.66Z",
    style: {
      fill: "rgb(240,0,180)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.741,275.259L69.34,442.659C112.182,485.501 171.367,511.999 236.741,511.999C350.417,511.999 442.57,406.006 442.57,275.258L236.741,275.258L236.741,275.259Z",
    style: {
      fill: "rgb(61,87,211)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.709,0.019C278.951,0.003 279.196,-0.004 279.443,0.004C406.026,4.1 507.9,105.974 511.996,232.558C512.137,236.9 508.613,240.482 504.268,240.482L481.083,240.482L481.083,232.558C477.517,106.083 388.888,4.279 278.709,0.019Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.709,0.019C278.614,0.014 278.519,0.007 278.424,0.004C274.64,-0.136 271.518,3.388 271.518,7.732C271.518,3.635 274.704,0.271 278.709,0.019Z",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.709,0.019C274.704,0.271 271.518,3.635 271.518,7.732L271.518,232.754C271.518,237.022 274.978,240.482 279.246,240.482L481.083,240.482L481.083,232.558C477.517,106.083 388.888,4.279 278.709,0.019Z",
    style: {
      fill: "rgb(2,219,140)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.90aa76acfc958a53d0eaa9cc7e4a66d2.svg";
export { ForwardRef as ReactComponent };